import { Container } from 'pixi.js';

/**
 * Camera container that applies per-frame screen-shake offsets to its child
 * game layer. Shake lives entirely in the renderer so it cannot affect
 * simulation determinism. Honors prefers-reduced-motion.
 */
export class Camera {
  readonly container: Container;
  private shake = 0;
  private readonly decayPerSec = 8;
  private readonly reducedMotion: boolean;

  constructor() {
    this.container = new Container();
    this.reducedMotion =
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /** Merge an engine shake intent with any renderer-side impulse. */
  setIntent(intent: number): void {
    if (this.reducedMotion) {
      this.shake = 0;
      return;
    }
    if (intent > this.shake) this.shake = intent;
  }

  /** Advance the decay and write out the offset. dtMs is renderer-frame dt. */
  update(dtMs: number): void {
    if (this.reducedMotion || this.shake <= 0) {
      this.container.x = 0;
      this.container.y = 0;
      this.shake = 0;
      return;
    }
    const amt = this.shake;
    this.container.x = (Math.random() * 2 - 1) * amt;
    this.container.y = (Math.random() * 2 - 1) * amt;
    const decay = this.decayPerSec * (dtMs / 1000);
    this.shake = Math.max(0, this.shake - decay);
  }
}
